import { useState } from "react";
import { toast } from "sonner";
import { Twitter, Facebook, MessageCircle, Link2, Check, Share2 } from "lucide-react";

const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "https://mommysliquidgold.com");

const SHARE_TITLE = "MommysLiquidGold — warm support for breastfeeding & pumping mamas";
const SHARE_TEXT = "I found this warm, honest support hub for breastfeeding and pumping mamas — check it out!";

export const SiteShare = ({ className = "", align = "center" }) => {
  const [copied, setCopied] = useState(false);
  const url = SITE_URL;
  const encUrl = encodeURIComponent(url);
  const encText = encodeURIComponent(SHARE_TEXT);

  const openWindow = (href) => window.open(href, "_blank", "noopener,noreferrer,width=600,height=520");

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: SHARE_TITLE, text: SHARE_TEXT, url });
      } catch {
        /* user cancelled */
      }
    } else {
      copyLink();
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied — share it with a fellow mama!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy — please copy the URL manually");
    }
  };

  const items = [
    {
      label: "Share on X",
      testid: "site-share-x",
      Icon: Twitter,
      onClick: () => openWindow(`https://twitter.com/intent/tweet?url=${encUrl}&text=${encText}`),
    },
    {
      label: "Share on Facebook",
      testid: "site-share-facebook",
      Icon: Facebook,
      onClick: () => openWindow(`https://www.facebook.com/sharer/sharer.php?u=${encUrl}`),
    },
    {
      label: "Share on WhatsApp",
      testid: "site-share-whatsapp",
      Icon: MessageCircle,
      onClick: () => openWindow(`https://api.whatsapp.com/send?text=${encText}%20${encUrl}`),
    },
  ];

  return (
    <div
      className={`flex flex-wrap items-center gap-2.5 ${align === "center" ? "justify-center" : ""} ${className}`}
      data-testid="site-share"
    >
      {navigator.share && (
        <button
          type="button"
          onClick={nativeShare}
          data-testid="site-share-native"
          className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground font-bold px-5 py-2.5 text-sm hover:-translate-y-0.5 transition-transform soft-shadow"
        >
          <Share2 className="h-4 w-4" /> Share
        </button>
      )}
      {items.map(({ label, testid, Icon, onClick }) => (
        <button
          key={testid}
          type="button"
          onClick={onClick}
          aria-label={label}
          data-testid={testid}
          className="h-10 w-10 rounded-full bg-background border border-border flex items-center justify-center text-muted-foreground hover:text-primary-foreground hover:bg-primary hover:-translate-y-0.5 transition-all"
        >
          <Icon className="h-[18px] w-[18px]" />
        </button>
      ))}
      <button
        type="button"
        onClick={copyLink}
        aria-label="Copy link"
        data-testid="site-share-copy"
        className="h-10 w-10 rounded-full bg-background border border-border flex items-center justify-center text-muted-foreground hover:text-primary-foreground hover:bg-primary hover:-translate-y-0.5 transition-all"
      >
        {copied ? <Check className="h-[18px] w-[18px]" /> : <Link2 className="h-[18px] w-[18px]" />}
      </button>
    </div>
  );
};

export default SiteShare;
